import { Box, Tooltip, Typography } from '@mui/material';
import { T, Icon, stitchTooltipSlotProps, StitchIconBtn } from '../ProjectOverview/parts/stitch';
import { FLOW_PHASES, STATUS_STYLES } from '../../config/projectFlow';

/**
 * De fasenbalk: klikbare fasen met status-bolletje. Uitgezette fasen staan er
 * niet in (de balk wordt korter — dát is de flow van dit project); terugzetten
 * kan via het tandwiel (PhaseSettingsDialog).
 */
function PhaseRail({ phases, activeKey, onSelect, onDisable, onOpenSettings, driftCount = 0 }) {
  const zichtbaar = phases.filter((p) => p.is_enabled);
  return (
    // Wrap i.p.v. horizontaal scrollen: een verborgen scrollbar liet fasen
    // onzichtbaar achter de knop rechts verdwijnen (leek overlap).
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, rowGap: 1, flexWrap: 'wrap', pb: 1 }}>
      {zichtbaar.map((p, i) => {
        const stijl = STATUS_STYLES[p.status] || STATUS_STYLES.todo;
        const actief = p.phase_key === activeKey;
        const meta = FLOW_PHASES[p.phase_key] || {};
        return (
          <Box key={p.id} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            {i > 0 && <Box sx={{ width: 10, height: 2, bgcolor: T.surfaceHigh, mx: 0.25 }} />}
            {/* Statustooltip alleen op het label, niet op de hele chip — anders
                stapelen de tooltips zodra je het ×-kruisje hovert. */}
            <Box onClick={() => onSelect(p.phase_key)} sx={{
              position: 'relative',
              display: 'flex', alignItems: 'center',
              px: 1.25, py: 0.7, borderRadius: '9999px', cursor: 'pointer',
              border: `1.5px solid ${actief ? T.tertiary : T.surfaceHigh}`,
              bgcolor: actief ? T.tertiaryContainer + '55' : T.surface,
              transition: 'all 0.15s ease',
              '&:hover': { borderColor: T.tertiary, bgcolor: T.surfaceLow },
              '&:hover .fase-weg': { opacity: 1 },
            }}>
              <Tooltip slotProps={stitchTooltipSlotProps}
                title={`${stijl.label} — ${(p.evidence || []).join(' · ') || p.status_source}`}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                  <Box sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: stijl.color, flexShrink: 0 }} />
                  {meta.icon && <Icon name={meta.icon} size={15} sx={{ color: actief ? T.tertiary : T.outline }} />}
                  <Typography sx={{ fontFamily: T.font, fontSize: '0.8rem',
                    fontWeight: actief ? 800 : 600, color: actief ? T.tertiary : T.text, whiteSpace: 'nowrap' }}>
                    {p.label}
                  </Typography>
                  {p.status_override && (
                    <Icon name="push_pin" size={13} sx={{ color: T.outlineVariant }} />
                  )}
                </Box>
              </Tooltip>
                {/* Fase weg-klikken direct op de chip (omkeerbaar via het tandwiel) */}
                {zichtbaar.length > 1 && (
                  <Tooltip title="Fase uitzetten voor dit project (terugzetten kan via het tandwiel)" slotProps={stitchTooltipSlotProps}>
                    <Box className="fase-weg"
                      onClick={(e) => { e.stopPropagation(); onDisable(p); }}
                      sx={{
                        position: 'absolute', top: -7, right: -7, width: 20, height: 20,
                        borderRadius: '50%', bgcolor: T.surface, border: `1.5px solid ${T.outlineVariant}`,
                        display: 'grid', placeItems: 'center', opacity: 0, transition: 'opacity 0.15s ease',
                        color: T.outline, '&:hover': { color: T.error, borderColor: T.error },
                      }}>
                      <Icon name="close" size={13} />
                    </Box>
                  </Tooltip>
                )}
              </Box>
          </Box>
        );
      })}
      <Box sx={{ flex: 1 }} />
      <StitchIconBtn onClick={onOpenSettings} title={`Fasen aanpassen${driftCount ? ` — ${driftCount} nieuwe fase beschikbaar` : ''}`}>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <Icon name="tune" size={20} />
          {driftCount > 0 && (
            <Box sx={{ position: 'absolute', top: -4, right: -6, width: 14, height: 14, borderRadius: '50%',
              bgcolor: T.amber, color: '#fff', fontSize: 9, fontWeight: 800,
              display: 'grid', placeItems: 'center', fontFamily: T.fontBody }}>
              {driftCount}
            </Box>
          )}
        </Box>
      </StitchIconBtn>
    </Box>
  );
}

export default PhaseRail;
